import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import {HolidayGroup} from "./components"
const HolidayGroup = lazy (() => import(/* webpackChunkName: "HolidayGroup" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/Holiday-group" component={HolidayGroup} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/HolidayGroup/routes.js